'use client'
import Image from 'next/image'
import { forwardRef, useState, type ComponentPropsWithoutRef, type ComponentRef, type CSSProperties } from 'react'

type SmoothImageProps = ComponentPropsWithoutRef<typeof Image> & {
    fadeIn?: boolean
}

const SmoothImage = forwardRef<ComponentRef<typeof Image>, SmoothImageProps>((props, ref) => {
    const { onLoad, fadeIn = false, ...otherProps } = props
    const [imageLoaded, setImageLoaded] = useState(false)
    const [imageLoadingComplete, setImageLoadingComplete] = useState(false)

    const handleOnLoad = (event: React.SyntheticEvent<HTMLImageElement>): void => {
        if (onLoad) {
            onLoad(event)
        }
        setImageLoaded(true)
    }

    const style: CSSProperties = (() => {
        if (fadeIn) {
            return imageLoadingComplete ? {} : { opacity: imageLoaded ? 1 : 0, transition: 'opacity 300ms ease-in-out' }
        }
        return {}
    })()
    return (
        <Image
            onTransitionEnd={() => {
                setImageLoadingComplete(true)
            }}
            style={style}
            ref={ref}
            onLoad={handleOnLoad}
            {...otherProps}
        />
    )
})

SmoothImage.displayName = 'SmoothImage'

export default SmoothImage
